import React from "react";
import auth from "../services/authService";
import { Navigate, useLocation } from "react-router-dom";

// react-router v6 wrapper: render the protected children when the user has a
// valid, unexpired JWT, otherwise redirect to /login (preserving the attempted
// location in navigation state, as the v4 <Redirect> did).
const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  const jwtTokenExpired = () => {
    const jwt = auth.getCurrentUser();
    if (!jwt) return true;
    const current_time = new Date().getTime() / 1000;
    return current_time > jwt.exp;
  };

  if (!auth.getCurrentUser() || jwtTokenExpired()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
